import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import worksData from '../assets/data.json';

const WorkDetail = () => {
    window.scrollTo(0, -20);
    const { id } = useParams();
    const [work, setWork] = useState(null);

    useEffect(() => {
        const foundWork = worksData.find((item) => String(item.id) === id);
        setWork(foundWork);
    }, [id]);

    if (!work) {
        return <h2 className="not-found">Page requested was not found</h2>;
    }

    const externalUrl = work.articleUrl || work.videoUrl || work.imdbUrl;

    return (
        <div>
            <div className="work-detail-container">
                <img src={work.imageUrl} alt={work.title} className="work-detail-image" />
                <h2 className="work-detail-title">{work.title}</h2>
            </div>
            <div className="detail-box">
                <div className="detail-text-container">
                    {work.writer === work.director ? (
                        <div>
                            <h5>WRITTEN AND DIRECTED BY</h5>
                            <span className="work-data-span">{work.director}</span>
                        </div>
                    ) : (
                        <>
                            <div>
                                <h5>WRITTEN BY</h5>
                                <span className="work-data-span">{work.writer}</span>
                            </div>
                            <div>
                                <h5>DIRECTED BY</h5>
                                <span className="work-data-span">{work.director}</span>
                            </div>
                        </>
                    )}
                    <div>
                        <h5>RELEASE DATE</h5>
                        <span className="work-data-span1">{work.date}</span>
                    </div>
                </div>
                <div className="detail-cast-container">
                    <h5>FEATURED</h5>
                    <div className="cast-list-container">
                        {work.cast && work.cast.length > 0 ? (
                            work.cast.map((actor, index) => (
                                <div>
                                    <span key={index} className="work-data-span">{actor}</span>
                                </div>
                            ))
                        ) : (
                            <span className="work-data-span">No cast information available</span>
                        )}
                    </div>
                    <div className="section-separator"></div>
                </div>
                <div className="logline-container">
                    <span>{work.logline}</span>
                    {externalUrl && (
                        <a href={externalUrl} className="logline-note-card" target="_blank" rel="noopener noreferrer"> More...</a>
                    )}
                </div>
            </div>
        </div>
    );
};

export default WorkDetail;




// master data

//   "title": "",
//   "format": "",
//   "date": "",
//   "director": "",
//   "producer": "",
//   "executiveProducer": "",
//   "associateProducer": "",
//   "writer": "",
//   "cast": [""],
//   "logline": "",
//   "imageUrl": "/assets/projectsPic/",
//   "videoUrl": "",
//   "articleUrl": "",
//   "imdbUrl":""